'use client';

import React, { useEffect, useState } from 'react';
import { StationMapView } from '@/components/features/map/station-map-view';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { Loader2 } from 'lucide-react';

export function StationMapPage() {
  useDocumentTitle('주유소 지도 - WJPNC');
  const [isMapReady, setIsMapReady] = useState(false);
  
  // Simulate map initialization delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMapReady(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!isMapReady) {
    return (
      <div className="h-screen w-full bg-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="size-8 animate-spin mx-auto mb-2 text-blue-600" />
          <p className="text-sm text-gray-600">지도를 로딩하고 있습니다...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="h-screen w-full bg-background">
      <StationMapView />
    </div>
  );
}